import { commentsLengthError } from '../shared/commentsValidation';

const normalizeNumber = value =>
    value === '' || value === null || value === undefined ? null : Number(value);

export const creditHoursError = form => {
    const minimum = normalizeNumber(form.creditMin);
    const maximum = normalizeNumber(form.creditMax);
    if (minimum === null || maximum === null) {
        return 'Enter both Minimum and Maximum credit hours.';
    }
    if (minimum <= 0 || maximum <= 0) {
        return 'Credit Hours Minimum and Maximum must be greater than 0.';
    }
    if (minimum > maximum) {
        return 'Credit Hours Maximum must be greater than or equal to Minimum.';
    }
    return null;
};

export const hasNewProgramValidationErrors = (form, maximumCommentsLength) =>
    !form.programName?.trim() ||
    !form.cipCode ||
    !form.institutionId ||
    !form.locations?.length ||
    !form.degreeLevel ||
    form.deliveryMode === null ||
    (form.deliveryMode === 3 && form.onlineNature === null) ||
    creditHoursError(form) !== null ||
    commentsLengthError(form.comments, maximumCommentsLength) !== null;
